import styled from "styled-components";

import { Box } from "@similarweb/ui-components/foundations";

import { HorizontalRadioSelect, RadioSelect } from "app/pages/sales-intelligence/common-components/form-fields";

/** @deprecated use direct import */
export { FilterContentContainer } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/styles";

export const StyledCountryDropdownContainer = styled(Box)<{ customWidth?: number }>`
    position: relative;
    ${({ customWidth }) => customWidth && `width: ${customWidth}px;`}
`;

export const StyledRadioSelect = styled(HorizontalRadioSelect)`
    margin-bottom: 8px;
`;

export const StyledHorizontalRadioSelect = styled(RadioSelect)`
    align-items: center;
    display: flex;
    gap: 12px;

    & > div {
        margin-right: 0 !important;
    }
`;

export const StyledVerticalRadioSelect = styled(RadioSelect)`
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
    gap: 12px;
`;
